<template>
  <div>
    <v-dialog v-model="dialog" width="700" v-if="descriptionPopup">
      <v-card class="px-6 py-3">
        <div class="text-right">
          <v-btn @click="dialog = false" icon><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <div v-html="descriptionPopup"></div>
      </v-card>
    </v-dialog>
    <v-btn color="primary" text small class="mb-3" v-if="descriptionPopup" @click="dialog = true"
      ><v-icon class="mr-2">mdi-information</v-icon> Plus d'informations</v-btn
    >
  </div>
</template>
<script>
export default {
  props: {
    descriptionPopup: String
  },

  data() {
    return {
      dialog: false
    }
  }
}
</script>